import { useState } from 'react';
export const usePagination = () => {
    const initialPaginationState = {
        currentPage: 1,
        pageSize: 100,
        sortColumn: undefined,
        sortDirection: undefined,
    };
    const initialStatsState = {
        totalRows: 0,
        totalPages: 1,
    };
    const [pagination, setPagination] = useState(initialPaginationState);
    const [stats, setStats] = useState(initialStatsState);
    const handlePageSizeChange = (val) => {
        const newPageSize = parseInt(val) || 10;
        setPagination((prev) => (Object.assign(Object.assign({}, prev), { pageSize: newPageSize })));
    };
    const handlePageChange = (val) => {
        const newPage = parseInt(val) || 1;
        if (newPage >= 1 && newPage <= stats.totalPages) {
            setPagination((prev) => (Object.assign(Object.assign({}, prev), { currentPage: newPage })));
        }
    };
    const handlePreviousPage = () => {
        setPagination((prev) => prev.currentPage > 1
            ? Object.assign(Object.assign({}, prev), { currentPage: prev.currentPage - 1 }) : prev);
    };
    const handleNextPage = () => {
        setPagination((prev) => prev.currentPage < stats.totalPages
            ? Object.assign(Object.assign({}, prev), { currentPage: prev.currentPage + 1 }) : prev);
    };
    const resetPagination = () => {
        setPagination(initialPaginationState);
        setStats(initialStatsState);
    };
    return {
        pagination,
        stats,
        setPagination,
        setStats,
        handlePageSizeChange,
        handlePageChange,
        handlePreviousPage,
        handleNextPage,
        resetPagination,
    };
};
//# sourceMappingURL=usePagination.js.map